(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EventPlaceSearch', EventPlaceSearch);

    EventPlaceSearch.$inject = ['$resource'];

    function EventPlaceSearch($resource) {
        var resourceUrl =  'api/_search/event-places/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
